// define wsImport reducers.

import WsImportConst from '../constants/wsImport.constants';

const WsImportReducers = (state = {}, action) => {

  switch (action.type) {
    case WsImportConst.SHOW_COMP: // update whic comp need to shoe
      let components = state.showComp.slice();
      if (action.value.action == 'show') {
        if ($.inArray(action.value.compName, state.showComp) == -1) {
          components.push(action.value.compName);
        }
      } else if (action.value.action == 'hide') {
        if (action.value.compName == '') {
          components.splice(0, state.showComp.length);
        } else {
          const index = components.indexOf(action.value.compName);
          if (index != -1) { components.splice(index, 1); }
        }
      }
      return { ...state, ...{ showComp: components } };

    case WsImportConst.IMPORT_FROM:
      return { ...state, ...{importFrom: action.value.importFrom} };

    case WsImportConst.UPDATE_EXTERNAL_APP:
      let externalApps = { ...state.externalApps };
      externalApps[action.externalApp] = action.value;
      return { ...state, ...{externalApps} };

    case WsImportConst.ITEM_TO_BE_IMPORT:
      return { ...state, ...{ itemToBeImport: action.items_to_be_import.data } };

    case WsImportConst.SAVE_IMPORT_DATA:
      return { ...state, ...{saveImportData: action.items} };

    case WsImportConst.GIT_REPOSITORIES_DATA:
      return { ...state, ...{gitRepositoriesData: action.items} };

    case WsImportConst.SAVE_REPOSITORIES_DATA:
      return { ...state, ...{repositorieId: action.items} };

    case WsImportConst.SAVE_REPOSITORIES_ERROR:
      return { ...state, ...{repositorieError: action.items} };

    case WsImportConst.SAVE_REPOSITORIES_MULTIPLE_DATA:
      let repositorieIds = state.repositorieIds ? state.repositorieIds.slice() : [];
      if (action.items == 'empty') {
        repositorieIds = [];
      } else if (action.checked == false) {
        const index = repositorieIds.indexOf(action.items);
        if (index > -1) {
          repositorieIds.splice(index, 1);
        }
      } else {
        repositorieIds.push(action.items);
      }
      return { ...state, ...{repositorieIds} };

    case WsImportConst.SAVE_PROJECT_MULTIPLE_DATA:
      let projectIds = state.projectIds ? state.projectIds.slice() : [];
      if (action.empty == 'empty') {
        projectIds = [];
        if (action.appType == 'jira') {
          console.log('action.items', action.items);
          projectIds = [action.items];
        } else {
          projectIds.push(action.items);
        }
      } else if (action.items == 'empty') {
        projectIds = [];
      } else if (action.checked == false) {
        const index = projectIds.indexOf(action.items);
        if (index > -1) {
          projectIds.splice(index, 1);
        }
      } else if (action.appType == 'jira') {
        console.log('action.items', action.items);
        projectIds = [action.items];
      } else {
        projectIds.push(action.items);
      }
      return { ...state, ...{projectIds} };
    case WsImportConst.SAVE_SYNC_TASK:
      return { ...state, ...{syncTask: action.items || false } };

    case WsImportConst.SET_PROJECT_DATA:
      console.log('SET_PROJECT_DATA test');
      return { ...state, ...{projectData: action.items, projectType: action.projectType} };

    case WsImportConst.SWITCH_BASIC_JQL:
      console.log('SWITCH_BASIC_JQL test', action.externalApp);
      if (action.externalApp == 'jira') {
        return { ...state, ...{projectIds: [], isJql: false} };
      }
      else {
        return state;
      }

    case WsImportConst.SAVE_INSTANCES:
      return { ...state, ...{instances: action.instances} }

    case WsImportConst.SET_SELECTED_INSTANCE:
      return { ...state, ...{selectedInstance: action.instance} }

    case WsImportConst.SET_IS_JQL:
      return { ...state, ...{isJql: action.isJql} }

    case WsImportConst.SET_WS_NAME:
      return { ...state, ...{wsName: action.wsName} }

    default:
      return state;
  }
};

export default WsImportReducers;
